import { messages } from './messages';
import { BillingPlanIds } from '../../../../../../../enums/billing-plan-ids';

export const planHighlightsMessageMap = {
  [BillingPlanIds.Free2025Q2]: [messages.discountedCarrierRates, messages.trackingEmails, messages.oneStoreConnection],
  [BillingPlanIds.Starter2025Q2]: [
    messages.unlimitedStoreConnections,
    messages.automatedRateShopping,
    messages.returnLabels,
    messages.basicAutomations,
    messages.reporting,
    messages.chatSupport,
  ],
  [BillingPlanIds.Standard2025Q2]: [
    messages.unlimitedAutomations,
    messages.combineSplitOrders,
    messages.bringYourExistingCarrierAccount,
    messages.advancedReturnFeatures,
    messages.basicWarehouseManagementAndInventorySync,
    messages.inventoryTrackingSyncAndProductBundles,
    messages.shippingAPI,
    messages.phoneSupport,
  ],
  [BillingPlanIds.Premium2025Q2]: [
    messages.inventoryManagement,
    messages.advancedWarehouse,
    messages.customAnalytics,
    messages.autoRouting,
    messages.cubiscan,
    messages.openDatabaseConnectivity,
  ],
  [BillingPlanIds.Starter2025Q2Annual]: [
    messages.unlimitedStoreConnections,
    messages.automatedRateShopping,
    messages.returnLabels,
    messages.basicAutomations,
    messages.reporting,
    messages.chatSupport,
  ],
  [BillingPlanIds.Standard2025Q2Annual]: [
    messages.unlimitedAutomations,
    messages.combineSplitOrders,
    messages.bringYourExistingCarrierAccount,
    messages.advancedReturnFeatures,
    messages.basicWarehouseManagementAndInventorySync,
    messages.inventoryTrackingSyncAndProductBundles,
    messages.shippingAPI,
    messages.phoneSupport,
  ],
  [BillingPlanIds.Premium2025Q2Annual]: [
    messages.inventoryManagement,
    messages.advancedWarehouse,
    messages.customAnalytics,
    messages.autoRouting,
    messages.cubiscan,
    messages.openDatabaseConnectivity,
  ],
};
